<template>
    <div class="col-11 col-lg-3 fs-2 text-start mb-5">
        {{ title }}
    </div>
    <div class="col-lg-9"></div>
</template>

<script>
export default {
    name: "CategoryColorComponent",
    props: {
        title: String
    }
}
</script>